"use strict";
import { createAction } from "@reduxjs/toolkit";
import { call, take } from "typed-redux-saga";
import { logger } from "utilities/src/logger/logger";
export function createSaga(saga, name) {
  const triggerAction = createAction(`${name}/trigger`);
  const wrappedSaga = function* () {
    while (true) {
      try {
        const trigger = yield* take(triggerAction.type);
        logger.debug("saga", "wrappedSaga", `${name} triggered`);
        yield* call(saga, trigger.payload);
      } catch (error) {
        logger.error(error, {
          tags: { file: "utils/saga", function: "createSaga" },
          extra: { sagaName: name }
        });
      }
    }
  };
  return {
    wrappedSaga,
    actions: {
      trigger: triggerAction
    }
  };
}
export const interruptTransactionFlow = createAction(`interruptTransactionFlow`);
